import ReactDOM from "react-dom/client";
import { Suspense } from "react";
import MainRouter from "./MainRouter";
import LoadingAcorn from "./components/LoadingAcorn";
import "./styles/index.css";    // import index.css

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
    <Suspense fallback={<LoadingAcorn />}>
        <MainRouter />
    </Suspense>
);
